// スライドショー画像アスペクト比チェッカー
class SlideshowAspectChecker {
  constructor() {
    this.targetAspectRatio = 5 / 3; // 5:3比率
    this.tolerance = 0.05; // 許容誤差（5%）
    this.init();
  }

  init() {
    // DOMContentLoaded後に実行
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.checkAllSlides());
    } else {
      this.checkAllSlides();
    }
  }

  checkAllSlides() {
    const slideshow = document.querySelector('.slideshow--aspect-ratio-5-3');
    if (!slideshow) return;

    const slides = slideshow.querySelectorAll('.slideshow__slide');
    slides.forEach((slide, index) => this.checkSlide(slide, index + 1));
  }

  checkSlide(slide, slideNumber) {
    const img = slide.querySelector('.slideshow__media img');
    if (!img) return;

    // 画像が既に読み込まれている場合
    if (img.complete && img.naturalWidth && img.naturalHeight) {
      this.validateAspectRatio(slide, img, slideNumber);
    } else {
      // 画像読み込み完了を待つ
      img.addEventListener('load', () => {
        this.validateAspectRatio(slide, img, slideNumber);
      });
      
      // エラー時の処理
      img.addEventListener('error', () => {
        this.showError(slide, slideNumber, '画像の読み込みに失敗しました');
      });
    }
  }

  validateAspectRatio(slide, img, slideNumber) {
    const actualRatio = img.naturalWidth / img.naturalHeight;
    const difference = Math.abs(actualRatio - this.targetAspectRatio);
    const isValid = difference <= this.tolerance;

    if (!isValid) {
      const actualRatioText = `${Math.round(actualRatio * 100) / 100}:1`;
      const expectedRatioText = `${this.targetAspectRatio}:1 (約1.67:1)`;
      const message = `現在: ${actualRatioText}<br>推奨: ${expectedRatioText}<br><br>5:3の比率に近い画像をご使用ください`;
      
      this.showError(slide, slideNumber, message);
      
      // コンソールにも警告を出力
      console.warn(`スライド${slideNumber}: アスペクト比が5:3ではありません`, {
        actual: actualRatio,
        expected: this.targetAspectRatio,
        difference: difference,
        image: img.src
      });
    }
  }

  showError(slide, slideNumber, message) {
    // 既存のエラー表示を削除
    const existingError = slide.querySelector('.slideshow__aspect-error');
    if (existingError) {
      existingError.remove();
    }

    // エラー表示要素を作成
    const errorDiv = document.createElement('div');
    errorDiv.className = 'slideshow__aspect-error';
    errorDiv.innerHTML = `
      <div class="slideshow__aspect-error-title">
        ⚠️ 画像アスペクト比エラー
      </div>
      <div class="slideshow__aspect-error-message">
        ${message}
      </div>
    `;

    // スライドのメディアコンテナに追加
    const mediaContainer = slide.querySelector('.slideshow__media');
    if (mediaContainer) {
      mediaContainer.appendChild(errorDiv);
    }
  }

  // 手動でチェックを再実行するメソッド
  recheck() {
    // 既存のエラー表示をすべてクリア
    document.querySelectorAll('.slideshow__aspect-error').forEach(error => error.remove());
    // 再チェック実行
    this.checkAllSlides();
  }
}

// インスタンス作成と初期化
const slideshowChecker = new SlideshowAspectChecker();

// グローバルに公開（デバッグ用）
window.slideshowChecker = slideshowChecker;